import React, { useContext } from 'react';
import {
	ICreateGameContext,
	CreateGameContext,
} from 'modules/Entertainment/Games/CreateGame/createGameState/createGameContext';
import { TranslationForm } from 'components/TranslationForm/TranslationForm';

interface ITranslationsForm {
	isVisible: boolean;
}

const TranslationsForm: React.FC<ITranslationsForm> = ({ isVisible }) => {
	const {
		setTranslationTab,
		changeNameTranslation,
		changeDescriptionTranslation,
		IDsSelectedLanguages,
		translations,
		selectedTranslationTab,
		fetchedLanguages,
	} = useContext<ICreateGameContext>(CreateGameContext);
	return (
		<TranslationForm
			setTranslationTab={setTranslationTab}
			changeNameTranslation={changeNameTranslation}
			changeDescriptionTranslation={changeDescriptionTranslation}
			isVisible={isVisible}
			IDsSelectedLanguages={IDsSelectedLanguages}
			translations={translations}
			selectedTranslationTab={selectedTranslationTab}
			fetchedLanguages={fetchedLanguages}
		/>
	);
};

export default TranslationsForm;
